<template>
  <drag-modal :visible="$store.state.dislog.police" @cancel="reset" :title="'添加进度-' + litetit" :class="{ editbox: Edit }" width="860px">
    <div class="navbox" v-if="Edit">
      <Nscroll @getIndex="see" @delCopy="copydel" :openEdit="openEdit"></Nscroll>
      <div class="intopbtn" v-if="!isAllDis">
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
          <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
        </a-popconfirm> -->
        <a-button icon="edit" v-if="$common.AccAUTH($store.state.cause.accuser.id,$store.getters.stepPower.edit) && $store.getters.publicPower" style="margin-left: 10px" @click="openEdit = !openEdit">{{ openEdit ? '修改' : '取消修改' }}</a-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }">
          <a-form-model-item label="类型" prop="type" :rules="{required: true, message: '请选择类型', trigger: 'change',}" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" v-if='step!=120'>
            <a-select v-model="form.type" placeholder="请选择类型" :disabled="openEdit">
              <a-select-option :value="0">请选择</a-select-option>
              <a-select-option :value="1">中止审理</a-select-option>
              <a-select-option :value="2">终止审理</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="时间" prop="time" :rules="{  required: true, message: '请选择时间', trigger: 'change' }" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
            <a-date-picker v-model="form.time" placeholder="请选择" style="width: 100%" type="date" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" :disabled="openEdit" />
          </a-form-model-item>
          <a-form-model-item label="原因" prop="reason" :rules="{ required: true,message: '请选择原因', trigger: 'change' }" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
            <a-select v-model="form.reason" placeholder="原因" :disabled="openEdit">
              <a-select-option :value="0">请选择</a-select-option>
              <a-select-option :value="1" >{{step==120? `${ygName}申请`:($store.state.cause.cause_type==1?'法院依职权':'调解中心依职权' )}}</a-select-option>
              <a-select-option :value="2">{{step==120?`${bgName}申请`:`${ygName}申请`}}</a-select-option>
              <a-select-option :value="3">{{step==120?'法院移送':`${bgName}申请`}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="事由" prop="matter" :rules="{ required: true, message: '请输入事由', trigger: 'blur' }" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
            <a-input type="text" placeholder="请输入事由" v-model="form.matter" :disabled="openEdit"></a-input>
          </a-form-model-item>
          <a-form-model-item label="承办人" prop="undertaker" :rules="{ required: false, message: '请输入承办人', trigger: 'blur' }" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }" v-if='step==120'>
            <a-input type="text" placeholder="请输入承办人" v-model="form.undertaker" :disabled="openEdit"></a-input>
          </a-form-model-item>
          <a-form-model-item label="联系方式" prop="tel" :rules="{ required: false, message: '请输入联系方式', trigger: 'blur' }" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }" v-if='step==120'>
            <a-input type="text" placeholder="请输入联系方式" v-model="form.tel" :disabled="openEdit"></a-input>
          </a-form-model-item>
          <a-form-model-item label="备注" prop="content" :rules="{ required: false, message: '请输入备注',trigger: 'change'}" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <Textarea v-model="form.content" @contentVal="(element) => {form.content = element;clearFileds()}" :edit="openEdit" :keyArr="['time', 'user']">
            </Textarea>
          </a-form-model-item>
          <div style="padding-left: 32px;">
            <div class="licter" v-if='!openEdit'>
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for='(i,index) in form.supp' :key='index'>
                <div class="likebox" v-if='i.type==1'>
                  <div class="htit">补充材料：电子
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'" :rules="{ required: true, message: '请输入平台名称',trigger: 'blur'}">
                        <a-input v-model="i.platform" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type==2'>
                  <div class="htit">补充材料：微信
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'" :rules="{ required: true, message: '请输入对方微信号',trigger: 'blur'}">
                        <a-input v-model="i.wx" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请输入补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type==3'>
                  <div class="htit">
                    补充材料：现场
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'" :rules="{ required: true, message: '请输入补充提交人',trigger: 'blur'}">
                        <a-input v-model="i.submiter" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请输入补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type==4'>
                  <div class="htit">
                    补充材料：邮寄
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'" :rules="{ required: true, message: '请输入单号',trigger: 'blur'}">
                        <a-input v-model="i.ship_no" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'" :rules="{ required: true, message: '请输入联系方式',trigger: 'blur'}">
                        <a-input v-model="i.tel" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'" :rules="{ required: true, message: '请输入收件人',trigger: 'blur'}">
                        <a-input v-model="i.receive_name" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'" :rules="{ required: true, message: '请选择寄出时间',trigger: 'change'}">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="">
                        <label v-if='openEdit'>{{i.gout=="a"?"签收时间:":(i.gout=="b"?"拒收时间:":"无")}}</label>
                        <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;" v-else>
                          <a-radio-button :value="null" style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                          <a-radio-button :value="'a'" style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout=="a"' :disabled='openEdit' style="width:100%;" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit' style="width:100%;" v-if='i.gout=="b"' />
                        <a-input disabled v-if='!i.gout' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='12'>
                      <a-form-model-item label="邮寄地址" :prop="'supp.' + index + '.addr'" :rules="{ required: true, message: '请输入邮寄地址',trigger: 'blur'}">
                        <a-input v-model="i.addr" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='12'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>

            <div class="licter" v-if='!openEdit'>
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon" style="margin-top:10px;">
              <div class="ilikebox" v-for='(i,index) in form.accept_file' :key='index'>
                <div class="likebox" v-if='i.type==1'>
                  <div class="htit">接收材料：电子
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'" :rules="{ required: true, message: '请输入平台名称',trigger: 'blur'}">
                        <a-input v-model="i.platform" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{ required: true, message: '请选择接收时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type==2'>
                  <div class="htit">接收材料：微信
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'" :rules="{ required: true, message: '请输入对方微信号',trigger: 'blur'}">
                        <a-input v-model="i.wx" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{ required: true, message: '请输入接收时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type==3'>
                  <div class="htit">
                    接收材料：现场
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'" :rules="{ required: true, message: '请输入接收人',trigger: 'blur'}">
                        <a-input v-model="i.submiter" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{ required: true, message: '请输入接收时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type==4'>
                  <div class="htit">
                    接收材料：邮寄
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'" :rules="{ required: true, message: '请输入单号',trigger: 'blur'}">
                        <a-input v-model="i.ship_no" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'" :rules="{ required: true, message: '请输入联系方式',trigger: 'blur'}">
                        <a-input v-model="i.tel" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}">
                        <a-input v-model="i.filename" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'" :rules="{ required: true, message: '请输入接收人',trigger: 'blur'}">
                        <a-input v-model="i.receive_name" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'" :rules="{ required: true, message: '请选择寄出时间',trigger: 'change'}">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit' style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="">
                        <label v-if='openEdit'>{{i.gout=="a"?"签收时间":(i.gout=="b"?"拒收时间":"无")}}</label>
                        <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;" v-else>
                          <a-radio-button :value="null" style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                          <a-radio-button :value="'a'" style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout=="a"' :disabled='openEdit' style="width:100%;" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit' style="width:100%;" v-if='i.gout=="b"' />
                        <a-input disabled v-if='!i.gout' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='12'>
                      <a-form-model-item label="邮寄地址" :prop="'accept_file.' + index + '.addr'" :rules="{ required: true, message: '请输入邮寄地址',trigger: 'blur'}">
                        <a-input v-model="i.addr" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='12'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top: 20px">
            <Upload :fList="form.files" @upFileAfter=" (element) => {  form.files = element; }" :edit="openEdit" v-if="!loading" :Wid="'102px'" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if="!openEdit" style="text-align: center">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width: 148px"> 提交 </a-button>
            </a-popconfirm>
            <a-button style="margin-left: 20px;width: 148px; background: #b2c9e1; color: #fff; " @click="reset">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>
</template>
<script>
const formItem = {
  content: [{}],
  reason: '',
  type: '',
  matter: '',
  time: '',
  files: [],
}
import Nscroll from '@/components/nscroll'
import Upload from '@/components/uploads'
import { mapGetters, mapActions } from 'vuex'
import { jcyspjdAdd, jcyspjdEdit, jcyspjdLists } from '@/server/speed'
import Textarea from '@/components/textarea'
export default {
  name:'Police',
  computed: {
    ...mapGetters(['litetit', 'Edit']),
    liteKey() {
      return this.step == 120 ? 'sxajzc' : "jcyspjd"
    },
    ygName(){
      return this.$store.state.cause.cause_type==1?'原告':'申请人'
    },
    bgName(){
      return this.$store.state.cause.cause_type==1?'被告':'被申请人'
    }
  },
  components: {
    Textarea,
    Upload,
    Nscroll,
  },
  data() {
    return {
      isAllDis: this.$route.query.t,
      form: JSON.parse(JSON.stringify(formItem)),
      step: this.$store.state.StepLite,
      rules: {},
      form: {
        supp: [],
        accept_file: [],
        content: [{}],
      },
      loading: true,
      openEdit: false,
    }
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        jcyspjdLists({
          cause_id: this.$store.state.cause.id,
          step: this.step,
        }, this.step).then((e) => {
          e.list.map((ele) => {
            ele[this.liteKey].content = JSON.stringify(ele[this.liteKey].content) == '{}' || JSON.stringify(ele[this.liteKey].content) == 'null' ? [{ content: '' }] : Object.keys(ele[this.liteKey].content).map((key) => ele[this.liteKey].content[key])
          })
          this.Infokey({ key: 'infoList', value: e.list })
          this.see(0)
          this.$store.dispatch("settime",e.list[0][this.liteKey].update_time)
        })
        this.openEdit = true
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    clearFileds() {
      this.$refs.forms.clearValidate(['content'])
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove',
    }),
    async copydel(index) {
      //删除进度
      this.loading = true
      await this.Newdel({
        index: index,
        formKey: ['content', 'reason', 'type', 'matter', 'time'],
        valkey: this.liteKey,
      }).then((e) => {
        this.form = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    confirm() {
      this.$refs.forms.validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd =
            this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0
              ? true
              : false //当前是否是在修改下的新增
          if (form.files && form.files.length > 0) {
            form.files = form.files.map((ele) => {
              return ele.upload_id || ele
            })
          }
          form.content=form.content.filter(ele=>{return ele.content})
          form.step = this.$store.state.StepLite
          if (form.type == 0 || form.reason == 0) {
            this.$message.error({ content: '请选择', key: 'updatable' })
            return false
          }
          if (this.Edit && !isEditCopyAdd) {
            //修改
            let step_id = this.$store.state.DisForm.infoList[curIndex][this.liteKey].id
            form.id = step_id
            jcyspjdEdit(form, this.step).then((e) => {
              this.$message.success({ content: '修改成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.openEdit = true
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            jcyspjdAdd(form, this.step).then((e) => {
              this.$message.success({ content: '新增成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    copyNew() {
      //新增复制进度
      this.loading = true
      let copyItem = {
        cause_id: null,
        id: null,
        jcyspjd: formItem,
        title: this.litetit,
      }
      this.addNew(copyItem).then((index) => {
        this.form = JSON.parse(JSON.stringify(formItem))
        this.loading = false
      })
    },
    async see(index) {
      //查看切换 审批
      this.loading = true
      this.seeInfo({
        index: index,
        formKey: this.step == 120 ? ['content', 'reason', 'undertaker', 'matter', 'time', 'tel', 'accept_file', 'supp'] : ['content', 'reason', 'type', 'matter', 'time', 'accept_file', 'supp'],
        valkey: this.liteKey,
      }).then((e) => {
        let form = JSON.parse(JSON.stringify(e))
        form.accept_file = form.accept_file || []
        form.supp = form.supp || []
        this.form = form
        this.loading = false
      })
    },
    reset() {
      this.reMove().then((e) => {
        this.$refs.forms.resetFields()
        this.$store.dispatch('openkey', { key: 'police', by: false })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  },
}
</script>
<style lang="less" scoped>
.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  label {
    float: left;
    font-size: 14px;
    text-align: right;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }
  .clearbtn {
    float: left;
  }
  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;
    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;
      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
.ilikecon {
  max-height: 400px;
  overflow-y: auto;
}
.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;
  .htit {
    font-size: 16px;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;
    span {
      color: #f00;
      cursor: pointer;
    }
  }
  /deep/ .ant-form-item {
    margin-bottom: 0;
  }
  /deep/ .ant-form-item-label {
    text-align: left;
  }
}
</style>